import { Component } from '@angular/core'
import { AgRendererComponent } from 'ag-grid-angular'
import moment from 'moment-timezone'

@Component({
  selector: 'app-date-time-column-renderer',
  template: ` {{ processDate() }} `,
  standalone: false
})
export class DateTimeColumnRendererComponent implements AgRendererComponent {
  private params: any

  agInit(params: any): void {
    this.params = params
  }

  refresh(params: any): boolean {
    return false
  }

  private getTimeZone(): string {
    if (this.params.data && this.params.data.IanaTimeZone) {
      return this.params.data.IanaTimeZone
    }

    if (this.params.colDef.refData && this.params.colDef.refData.IanaTimeZone) {
      return this.params.colDef.refData.IanaTimeZone
    }

    return ''
  }

  private getParsingValue(): string {
    if (this.params.altValue && this.params.data[this.params.altValue]) {
      return this.params.data[this.params.altValue]
    }

    return this.params.value
  }

  processDate(): string {
    const format = this.params?.colDef?.refData?.dateFormat
    const parsingValue = this.getParsingValue()
    const timezone = this.getTimeZone()
    const date = moment.tz(parsingValue, timezone)
    if (date.isValid()) {
      if (timezone) {
        return date.format(format ?? 'MM/DD/YYYY HH:mm z')
      }

      return date.format(format ?? 'MM/DD/YYYY HH:mm')
    }
    return ''
  }
}
